import React, { useState } from 'react';
import './SummaryScreen.css';

const SummaryScreen = ({ 
  userAnswers, 
  score, 
  totalQuestions, 
  totalDiscount, 
  onPlayAgain, 
  onReset 
}) => {
  const [showDialog, setShowDialog] = useState(false);

  const handleCashierConfirm = () => {
    setShowDialog(true);
  };

  const handleEndChallenge = () => {
    setShowDialog(false);
    onReset();
  };

  return (
    <div className="summary-screen">
      <div className="screen-header">
        <div className="header-logos">
<img src="/saudi95.png" alt="شعار اليوم الوطني 95" className="national-logo" />          
<img src="/benchlogocropped.png" alt="شعار المقهى" className="cafe-logo" />
          
        </div>
      </div>
      
      <div className="summary-content">
        <div className="summary-header">
          <h1>انتهت المسابقة!</h1>
        </div>

        <div className="results-card">
   
          <div className="discount-summary">
            <div className="discount-circle">
              <div className="discount-percentage">{totalDiscount}%</div>
              <div className="discount-label">خصم إجمالي</div>
            </div>
          </div>
        </div>

        <div className="detailed-results">
          <h3>تفاصيل الأسئلة</h3>
          <div className="questions-review">
            {userAnswers.map((answer, index) => (
              <div key={answer.questionId} className={`question-review ${answer.isCorrect ? 'correct' : 'incorrect'}`}>
                <div className="question-number">سؤال {index + 1}</div>
                <div className="question-text">{answer.question}</div>
                <div className="answer-status">
                  {answer.isCorrect ? '✅ صحيح' : '❌ خطأ'}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="action-buttons">
          <button className="cashier-confirm-button" onClick={handleCashierConfirm}>
            <span>تأكيد الخصم - الكاشير</span>
            <div className="button-discount">{totalDiscount}%</div>
          </button>
          
          <button className="play-again-button" onClick={onReset}>
            <span>إعادة المسابقة</span>
          </button>
        </div>
      </div>
      
      <div className="footer-strap">
        <img src="/footerstrap.png" alt="شريط سفلي" className="footer-image" />
      </div>

      {/* Confirmation Dialog */}
      {showDialog && (
        <div className="dialog-overlay">
          <div className="dialog-content">
            <div className="dialog-header">
              <div className="dialog-icon">🎉</div>
              <h2>تم تأكيد الخصم!</h2>
            </div>
            
            <div className="dialog-body">
              <div className="discount-display">
                <div className="discount-circle-large">
                  <span className="discount-percentage-large">{totalDiscount}%</span>
                  <span className="discount-label-large">خصمك</span>
                </div>
              </div>
              
              <p className="dialog-message">
                تم تأكيد خصمك بنجاح! يمكنك الآن استخدام هذا الخصم في طلبك.
              </p>
            </div>
            
            <div className="dialog-actions">
              <button className="end-challenge-button" onClick={handleEndChallenge}>
                <span>إنهاء التحدي</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SummaryScreen;
